// extracted by mini-css-extract-plugin
export default {"Form":"Container_Form__VDBcI","Footer":"Container_Footer__1iCm7","Spinner":"Container_Spinner__dmd0B","SubmitButton":"Container_SubmitButton__PoD2p"};